export default $ => {

  // ===========================================================================
  // Funzioni
  // ===========================================================================

  /**
   * Estrae il selettore per il target
   */
  const getTargetSelector = toggle => {
    const dataToggle = toggle.data('toggle');
    return dataToggle ? dataToggle : toggle.attr('href');
  };

  /**
   * Attiva un pannello utilizzando l'animazione corretta. Se il pannello è
   * visibile verrà nascosto e viceversa
   */
  const switchPaneStatus = (paneSelector, toggleType) => {
    if (!toggleType) {
      toggleType = 'slideToggle';
    }

    if (paneSelector) {
      $(paneSelector)[toggleType]();
    }
  };

  /**
   * Nascondi un pannello se visibile
   */
  const hidePane = (paneSelector, toggleType) => {
    if (paneSelector && $(paneSelector).is(':visible')) {
      switchPaneStatus(paneSelector, toggleType);
    }
  };

  /**
   * Mostra un pannello se non visibile
   */
  const showPane = (paneSelector, toggleType) => {
    if (paneSelector && !$(paneSelector).is(':visible')) {
      switchPaneStatus(paneSelector, toggleType);
    }
  };

  /**
   * Attiva un pannello di una tab.
   */
  const performTabToggle = (toggle, activate) => {
    const target = getTargetSelector(toggle);
    const toggleType = toggle.data('toggle-type');
    const toggleClass = toggle.data('toggle-class');
    const action = activate ? showPane : hidePane;

    action(target, toggleType);
    toggle.data('active', !!activate);

    if (toggleClass) {
        if (activate) {
            toggle.addClass(toggleClass);
        } else {
            toggle.removeClass(toggleClass);
        }
    }
  };

  // initString should be one of 'closed' or 'opened'
  const initTarget = (target, initString) => {
    if (initString === 'closed') {
      const errors = target.find('.eField__Errors > .help-block').length;
      if(errors === 0) {
        target.hide();
      }
    } else if (initString === 'opened') {
      target.show();
    }
  };

  // ===========================================================================
  // Bootstrap
  // ===========================================================================
  let transitioning = false;

  $('[data-toggle-start]').each(function () {
    const toggle = $(this);
    const target = $(getTargetSelector(toggle));
    const startStatus = toggle.data('toggle-start');
    const rememberKey = toggle.data('toggle-remember');
    const rememberStatus = rememberKey ? window.localStorage.getItem(rememberKey) : null;
    const initStatus = rememberStatus ? rememberStatus : startStatus;
    initTarget(target, initStatus);
  });

  /**
   * Evento click
   */
  $('[data-toggle]').on('click', function (e) {
    if ( ! transitioning) {
      transitioning = true;
      const toggle = $(this);
      const target = getTargetSelector(toggle);
      const targetWasVisible = ($(target).is(':visible'));
      const tabGroup = toggle.data('toggle-tab');
      const toggleType = toggle.data('toggle-type');
      const gotoType = toggle.data('toggle-goto');

      if (tabGroup) {
        // Tab mode: always show target, hide other tabs
        if (!$(this).data('active')) {
          $(`[data-toggle-tab="${tabGroup}"]`).not(this).each(function() {
            performTabToggle($(this), false);
          });

          performTabToggle(toggle, true);
        }
      } else {
        // Standard mode: hide/show target
        const toggleClass = toggle.data('toggle-class');
        switchPaneStatus(target, toggleType);
        if (toggleClass) {
            toggle.toggleClass(toggleClass);
        }
      }

      if (!targetWasVisible) {
        switch (gotoType) {
          case 'scroll':
            $('html, body').animate({scrollTop: $(target).offset().top}, 500);
            break;

          case 'anchor':
            $('html, body').animate({scrollTop: $(target).offset().top}, 0);
            break;
        }
      }

      // Remember last status of the pane
      if (toggle.data('toggle-remember')) {
        const k = toggle.data('toggle-remember'); // session key
        window.localStorage.setItem(k, targetWasVisible ? 'closed' : 'opened');
      }

      transitioning = false;
    }
  });
};



// WEBPACK FOOTER //
// ./assets/js/component/toggle.js